module.exports = __webpack_public_path__ + "static/img/09prostokąt.39c3f2e6.png";